module.exports = __webpack_public_path__ + "img/icon115.cb744b7f.png";